import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';

export class Analista {
    constructor(asignarAnalistaRef) {
        this.model = {
            nombre: {
                header: 'Analista',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '230px' },
                body: (rowData) => (
                    <div className="flex align-items-center gap-3">
                        <i className="pi pi-user text-primary text-xl"></i>
                        <div className="flex flex-column">
                            <span className="font-bold text-900">{rowData.nombre}</span>
                            <span className="text-500 text-sm">ID: {rowData.identificacion}</span>
                        </div>
                    </div>
                )
            },
            email: {
                header: 'Email',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '180px' },
                body: (rowData) => (
                    <div className="flex flex-column" style={{ fontSize: '0.85rem' }}>
                        <span className="text-700"><i className="pi pi-envelope mr-1"></i>{rowData.email}</span>
                    </div>
                )
            },
            total_alertas_asignadas: {
                header: 'Alertas asignadas',
                table: true,
                sort: true,
                isNumeric: true,
                style: { minWidth: '110px' },
                body: (rowData) => {
                    const total = rowData.total_alertas_asignadas || 0;
                    let severity = 'success';
                    if (total > 5 && total <= 15) {
                        severity = 'warning';
                    } else if (total > 15) {
                        severity = 'danger';
                    }
                    return (
                        <div className="flex align-items-center gap-2">
                            <Tag severity={severity} value={total} rounded></Tag>
                            <span className="text-sm text-500">alertas</span>
                        </div>
                    );
                }
            },
            es_asignado: {
                header: 'Asignado',
                table: true,
                isBoolean: true,
                sort: true,
                filter: true,
                style: { width: '140px' },
                body: (rowData) => {
                    const isAsignado = rowData.es_asignado === true;

                    if (isAsignado) {
                        return (
                            <Button label="Quitar" icon="pi pi-user-minus" className="p-button-danger p-button-outlined p-button-sm"
                                onClick={() => {
                                    if (asignarAnalistaRef.current) {
                                        asignarAnalistaRef.current(rowData); // Llama a la misma función
                                    }
                                }}
                            />
                        );
                    }

                    return (
                        <Button label="Asignar" icon="pi pi-user-plus" className="p-button-primary p-button-outlined p-button-sm"
                            onClick={() => {
                                if (asignarAnalistaRef.current) {
                                    asignarAnalistaRef.current(rowData);
                                }
                            }}
                        />
                    );
                }
            }
        };
    }
}